
import Alert from 'react-bootstrap/Alert';
import LEVELS from './Levels';

function ScoreBoard(){
    return(
        <Alert variant="success" id ='score_bord'>
            <p id="level_badge" className="LevelBadge">{"Lv." + LEVELS[0].id + " · " + LEVELS[0].name}</p>
            <div className="score-row">
                <p className="score-item">
                    <span className="score-tag">Score</span>
                    <span id="score" className='ScoreValue'>000</span>
                </p>
                <p className="score-item">
                    <span className="score-tag">Time</span>
                    <span id="timer" className="TimerValue">00:00</span>
                </p>
            </div>
        </Alert>
    );

}
export default ScoreBoard;
